import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'shortenName',
})
export class ShortenNamePipe implements PipeTransform {
  transform(fullName: string): string {
    if (!fullName) {
      return '';
    }

    const names = fullName.split(' ');
    if (names.length >= 2) {
      const firstName = names[0];
      const middleNames = names.slice(1);
      const abbreviatedMiddleNames = middleNames
        .filter(name => name !== '')
        .map(name => `${name.charAt(0)}.`);
      return `${firstName} ${abbreviatedMiddleNames.join(' ')}`;
    }

    return fullName;
  }
}
